import axios from "axios";
import { getXSRFToken, getJwtToken } from "./session";

const UNAUTHORIZED = 401;

const axiosInstance = axios.create({
  baseURL: "/",
  headers: {
    Accept: "application/vnd.api+json",
    "Content-Type": "application/vnd.api+json",
    "x-csrf-token": getXSRFToken(),
    Authorization: `Bearer ${getJwtToken()}`,
  },
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === UNAUTHORIZED) {
      window &&
        window.location.assign(
          process.env.NODE_ENV === "development"
            ? `${process.env.PROXY_API_URL}/accounts/sign_in`
            : "/accounts/sign_in",
        );
    }
    return Promise.reject(error);
  },
);

const ApiClient = () => {
  axiosInstance.defaults.headers.common["x-csrf-token"] = getXSRFToken();
  axiosInstance.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${getJwtToken()}`;
  return axiosInstance;
};

export { ApiClient };
